<template>
  <div class="d-flex flex-column margin-top-50 mw tmw" dir="rtl" v-if="content">
    <div class="d-flex arrow-margin">
      <!-- <div :class="captionClazz" class="flex-grow-1" v-html="caption"></div> -->
      <a :class="captionClazz" v-if="content.link?.href" class="flex-grow-1 black-link" :href="content.link.href" @click="trackClick">{{caption}}</a>
      <div v-else :class="captionClazz" class="flex-grow-1 black-link" >{{caption}}</div>
      <div class="f14-l30 df18-l28 cef" v-if="content.link?.href"><a class="red-link" :href="content.link.href" @click="trackClick">{{content.link.text}}</a></div>
    </div>
    <HorizontalScrollContainer :rightJustify="rightJustify" >
      <div v-for="p in content.results" :key="p.result_kind + p.result_id" style="display:inline-block;" class="margin-lr-5 card-fixed-size">
        <CookCardComponent v-if="p.result_kind=='cook'" :result="p" />
        <CookDishCardPreviewComponent v-else-if="p.result_kind=='dish'" :dish="p.result" />
      </div>
    </HorizontalScrollContainer>
  </div>
</template>
<script>
import HorizontalScrollContainer from "@/components/generic/HorizontalScrollContainer.vue";
import CookCardComponent from "@/components/search/CookCardComponent.vue";
import CookDishCardPreviewComponent from "@/components/CookDishCardPreviewComponent.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
export default {
  components: {
    HorizontalScrollContainer,
    CookCardComponent,
    CookDishCardPreviewComponent
  },
  props: {
    content: Object,
    title: String,
    titleClass: String,
    rightJustify: Boolean
  },
  computed: {
    caption() {
      return this.content?.title || this.title;
    },
    captionClazz() {
      return this.titleClass || "f22-l30-b df36-l30-b";
    }
  },
  methods: {
    trackClick(event) {
      // Trigger Google Tag Manager event
      addGoogleAnalyticsDataLayer(this.content.data_layer);

      // Add a delay to ensure GTM captures the event before navigation
      setTimeout(() => {
        window.location.href = this.content.link.href;
      }, 100);
      
      // Prevent default click if you add the delay
      event.preventDefault();
    },
  },
}
</script>
<style scoped>
@media (min-width: 768px) {
  .arrow-margin {
    padding-left: 45px;
    padding-right: 45px;
  }
}

@media (min-width: 1200px) {
  .arrow-margin {
    padding-left: 45px;
    padding-right: 45px;
  }
}

</style>